import VSS = require("VSS/VSS");

export module BuildAdminActionIds {
    export var Settings = "settings";
    export var ResourceLimits = "resourceLimits";
}

// TFS plugin model requires this call for each tfs module.
VSS.tfsModuleLoaded("Controls.Admin", exports);
